<div class="login-form">
  <mat-card appearance="outlined" class="login-form__content">
    <mat-card-header>
      <mat-card-title> {{ 'Bitte melden Sie sich an' | translate }} </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="loginForm" class="login-form__form">
        <mat-form-field>
          <mat-label>{{ 'E-Mail' | translate }} </mat-label>
          <input
            matInput
            type="text"
            formControlName="email"
            autofocus
            id="email"
            placeholder="{{ 'E-Mail' | translate }}"
            required
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'Passwort' | translate }} </mat-label>
          <input matInput type="password" formControlName="password" id="password" required />
        </mat-form-field>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          (click)="login()"
          id="login-button"
          [disabled]="loginForm.invalid"
          class="login-form__button"
        >
          {{ 'Anmelden' | translate }}
        </button>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div>
        <a class="login-form__link" mat-button [routerLink]="'/auth/reset-password'" data-test-id="resetPassword">{{
          'Passwort vergessen?' | translate
        }}</a>
      </div>
      <div>
        <a class="login-form__link" mat-button [routerLink]="'/auth/register'" data-test-id="registerNow">{{
          'Noch keinen Account? Jetzt registrieren!' | translate
        }}</a>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
